var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "interface-classification"
  }, [_c("header", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.contentData.group_name))]), _c("div", {
    staticClass: "header-bottom"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("ul", {
    staticClass: "interfaceTag"
  }, _vm._l(_vm.contentData.group_label_name, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "tag"
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c("div", {
    staticClass: "header-btn-group"
  })])]), _c("main", [_vm.contentData.group_desc ? _c("div", {
    staticClass: "content-classfiy",
    domProps: {
      innerHTML: _vm._s(_vm.contentData.group_desc)
    }
  }) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };